import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../http/http.service';
import { ENDPOINTS } from '../../constants/endpoints';

export interface UserReportColumnsPreferences {
  id?: number;
  userId: number;
  reportName: string;
  columnPreferences: string; // JSON string
  modifiedDate?: Date;
}

@Injectable({ providedIn: 'root' })
export class ReportColumnPreferenceService {
      private httpService = inject(HttpService);

      

  getPreferences(payload: { userId: number; reportName: string }){
    const endpoint = `${ENDPOINTS.UserReportColumnPreference.Get}`;
    return this.httpService.get<any>(endpoint, payload, 'json', 'body', true);

  }
  savePreferences(requestPayload:any):Observable<UserReportColumnsPreferences>{
    const endpoint = `${ENDPOINTS.UserReportColumnPreference.InsertUpdate}`;
    return this.httpService.post<UserReportColumnsPreferences>(endpoint, requestPayload,'json','body',true);
  }
   
}
